import { useEffect } from 'react';
import { X } from 'lucide-react';

// FE-085 — finestra di conferma dell'eliminazione di piu' voci del listino
// (Regola 14: mai window.confirm). Stessa struttura di NomeGiaPresenteModal:
// overlay + card + titolo con X + testo + azioni. I testi arrivano da
// `testiConfermaElimina` (listinoLogic.js), cosi' la logica si prova in jest.
// `testi` null = finestra chiusa. `occupato` blocca i bottoni durante la chiamata.
export default function ListinoConfermaElimina({ testi, occupato, onAnnulla, onConferma }) {
  useEffect(() => {
    if (!testi) return undefined;
    const onKey = (e) => { if (e.key === 'Escape' && !occupato) onAnnulla(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [testi, occupato, onAnnulla]);

  if (!testi) return null;
  const chiudi = () => { if (!occupato) onAnnulla(); };

  return (
    <>
      <div onClick={chiudi} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1100 }} />
      <div
        role="dialog" aria-modal="true" aria-labelledby="listino-conferma-elimina-titolo"
        data-testid="listino-conferma-elimina"
        style={{
          position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
          width: 'min(92vw, 460px)', maxHeight: '85vh', overflowY: 'auto', zIndex: 1101,
          background: 'var(--ds-bg)', border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-card)',
          boxShadow: '0 20px 60px rgba(0,0,0,0.25)', padding: 24, display: 'flex', flexDirection: 'column', gap: 16,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
          <h2 id="listino-conferma-elimina-titolo" style={{ margin: 0, fontSize: 17, fontWeight: 500, fontFamily: 'var(--font-display)', color: 'var(--ink)', lineHeight: 1.3 }}>
            {testi.titolo}
          </h2>
          <button onClick={chiudi} aria-label="Chiudi" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--ds-muted)', padding: 0, minWidth: 44, minHeight: 44, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end' }}>
            <X size={20} strokeWidth={2} />
          </button>
        </div>
        <p data-testid="listino-conferma-elimina-testo" style={{ margin: 0, fontSize: 14, fontWeight: 400, color: 'var(--ds-text)', lineHeight: 1.55 }}>
          {testi.testo}
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap', marginTop: 4 }}>
          <button onClick={chiudi} disabled={occupato} style={btnSecondario}>Annulla</button>
          <button onClick={onConferma} disabled={occupato} style={{ ...btnPericolo, opacity: occupato ? 0.6 : 1 }}>
            {occupato ? 'Elimino…' : testi.bottone}
          </button>
        </div>
      </div>
    </>
  );
}

const btnBase = {
  minHeight: 44, padding: '10px 18px', borderRadius: 'var(--radius-base)', fontSize: 14,
  fontWeight: 500, fontFamily: 'inherit', cursor: 'pointer',
};
const btnPericolo = { ...btnBase, border: 'none', background: 'var(--ds-danger)', color: '#fff' };
const btnSecondario = { ...btnBase, border: '1px solid var(--ds-border)', background: 'var(--ds-bg)', color: 'var(--ink)' };
